/** main-map-query-content: formatted popup for querying the map */

<template>
    <div class="embed-map-query-popup">
        <h4 v-if="MPAText.length > 0">Marine Protected Areas</h4>
        <span v-for="(MPA, i) in MPAText">
            <span class="embed-link" v-on:click.prevent="redirect(MPA[1])">{{ MPA[0] }}</span><span v-if="i < MPAText.length - 1">, </span><span v-if="i === MPAText.length - 1">.</span>
        </span>

        <p v-if="MPAText.length > 0">&nbsp;</p>

        <h4 v-if="byelawText.length > 0">Byelaws prohibiting bottom-towed fishing gear</h4>
        {{ byelawText }}
    </div>
</template>


<script>


export default {
    name: "main-map-query-content",
    props: {
        queryData: {type: Object, required: true},
    },
    methods: {
        redirect: function (id) {
            return
            // todo: add once MPA browser site up - ALSO SORT STYLES BELOW
            // console.log("redir", id)
            if (window.location.hostname === "local.mpa-reality-check.org") {
                window.parent.location.href = "http://mpa.local.mpa-reality-check.org:8000/" + id + "/";
            } else if (window.location.hostname === "rc3.mpa-reality-check.org") {
                window.parent.location.href =  "https://mpa.rc3.mpa-reality-check.org/" + id + "/";
            } else {
                // window.parent.location.href =  "https://mpa.mcsuk.org/";
            }

        }
    },
    computed: {
        byelawText: function () {
            let blText = this.queryData.demersal_byelaws.map(x => x[1].trim()).join(", ");
            if (blText) {
                blText = blText + "."
            }
            return blText
        },
        MPAText: function () {
            const MPAs = [];

            this.queryData.MPAs.MCZ.forEach(mcz => MPAs.push([mcz[0] + " (MCZ)", mcz[1]]));
            this.queryData.MPAs.SAC.forEach(sac => MPAs.push([sac[0] + " (SAC)", sac[1]]));
            this.queryData.MPAs.SPA.forEach(spa => MPAs.push([spa[0] + " (SPA)", spa[1]]));
            this.queryData.MPAs.NCMPA.forEach(ncmpa => MPAs.push([ncmpa[0] + " (NCMPA)", ncmpa[1]]));

            return MPAs
        }
    }
}
</script>


<style lang="scss">
    @import "../../styles/variables.scss";

    .embed-map-query-popup {
        h4 {
            font-size: 16px;
            font-weight: normal;
            margin-bottom: 8px;
        }

        .embed-link {
            // todo: enable once MPA browser live
            //cursor: pointer;
            //text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }

        p {
            margin: 0 0 5px 0;
        }
    }
</style>